const workCarousel = document.querySelector('.js-work-carousel');

if(typeof workCarousel != "undefined" && workCarousel != null) {
    var flkty = new Flickity( workCarousel, {
        // options
        cellAlign: 'left',
        contain: false,
        cellSelector: '.previous-works__slide',
        prevNextButtons: false,
        pageDots: false
    }); 
}

const pressTextCarousel = document.querySelector('.js-press-text-carousel');

if(typeof pressTextCarousel != "undefined" && pressTextCarousel != null) {

    const pressTextCarouselPrev = document.querySelector('.js-press-text-carousel-prev');
    const pressTextCarouselNext = document.querySelector('.js-press-text-carousel-next');
    const pressImageCarousel = document.querySelector('.js-press-image-carousel');



    var pressTxtflkty = new Flickity( pressTextCarousel, {
        cellAlign: 'center',
        contain: false,
        cellSelector: '.press-quotes__slide',
        prevNextButtons: false,
        pageDots: false,
        wrapAround:true,
        draggable:false
    }); 

   

    var pressImgflkty = new Flickity( pressImageCarousel, {
        cellAlign: 'center',
        contain: false,
        cellSelector: '.press-quotes__img-wrapper',
        prevNextButtons: false,
        pageDots: false,
        wrapAround:true,
        asNavFor: '.js-press-text-carousel',
        draggable:false
    }); 

    pressTextCarouselPrev.addEventListener("click", () => {
        pressTxtflkty.previous();
    });

    pressTextCarouselNext.addEventListener("click", () => {
        pressTxtflkty.next();
    });

}